import {
  ICaseStudySearchPagedResponse,CaseStudySearchItem
} from "./../business-objects/common";
import { CaseStudySearchActionTypes } from "./types";
import * as notificationService from "../../../services/notificationService";
import Api from "../../../services/Api";
import { ApiResponse } from "apisauce";


export const getSearchResults = (url: string,  request: any) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response: ApiResponse<ICaseStudySearchPagedResponse> =
        await getPagedSearchResults(url, request);

      if (response.ok) {
        dispatch(setSearchResults(response.data));
      }
    } catch (ex) {
      console.log(ex);
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const getPagedSearchResults = async (
  url: string,
  request: any
): Promise<ApiResponse<ICaseStudySearchPagedResponse>> => {
  return await Api.post(url, request);
};

export const getExportData = async (
  url: string,
  request: any
): Promise<ApiResponse<ICaseStudySearchPagedResponse>> => {
  return await Api.post(url, request);
};

export const doExport = async (
  url: string,
  request: any
): Promise<ApiResponse<boolean>> => {
  return await Api.post(url, request);
};

export const setSearchResults = (value: ICaseStudySearchPagedResponse) => {
  return {
    type: CaseStudySearchActionTypes.GET_CASE_STUDY_RESULTS,
    value: value,
  };
};

export const setLoading = (value: boolean) => {
  return {
    type: CaseStudySearchActionTypes.LOADING,
    value: value,
  };
};

export const setSelectedRowsChangedR = (rows: any[]) => 
{
  return async(dispatch) => {
    dispatch(reduceSelectedRowsChangedR(rows));
  }
}
export const reduceSelectedRowsChangedR = (value: any[]) => {
  return {
    type: CaseStudySearchActionTypes.SET_SELECTED_ROWS,
    value: value,
  };
};